const Style = {
  base: 'relative clear-both border-0 p-0 last:mb-0',
  error: `border-0 pt-6 pl-4 pr-4 mb-4 before:absolute before:left-0 before:right-0 
    before:top-0 before:bottom-2 before:rounded before:border before:border-solid before:border-red-500`,
  errorMessage: 'clear-both top-0 -ml-4 -mr-4 mb-0',
  inlineRow: 'flex items-center gap-2',
  selectAllRow: 'mb-5 mt-2',
  inlineCheckbox: 'shrink-0',
  inlineLegend: 'inline normal-case mb-0',
  inlineInput: 'float-none self-center',
};

export default Style;
